//
//
//
//
//

import MHeader from '../Header/Header.vue';
export default {
    components: {
        MHeader,
    }
}



// WEBPACK FOOTER //
// ./src/components/DownLoad/DownLoadDetail.vue